import { render, staticRenderFns } from "./CustomerTabsEnquiries.vue?vue&type=template&id=68d54f6f&scoped=true&"
import script from "./CustomerTabsEnquiries.vue?vue&type=script&lang=js&"
export * from "./CustomerTabsEnquiries.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabsEnquiries.vue?vue&type=style&index=0&id=68d54f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d54f6f",
  null
  
)

export default component.exports